import React, { Fragment, useState, useContext } from "react";
// import { Link } from "react-router-dom";
import styled from "styled-components";
import { AppContext } from "../Utils/AppContext";
import { logoutUser } from "../Utils/User";

const AccountPreview = styled.div`
  &:hover {
    cursor: pointer;
  }
`;

const AccountMenuDropDown = styled.div`
  position: absolute;
  right: 30px;
  top: 66px;
  background: #fff;
  border: solid 1px #eaedf3;
  border-radius: 0 0 4px 4px;

  ul {
    li {
      &:not(:last-child) {
        border-bottom: solid 1px #eaedf3;
      }

      a {
        font-size: 15px;
        padding: 14px 20px;
        display: flex;
        color: #6b6c6f;
        text-decoration: none;

        &:hover {
          background: #eaedf3;
        }
      }
    }
  }
`;

const AccountMenu = () => {
  const [accountMenuState, setAccountMenuState] = useState({
    menuOpen: false
  });

  const context = useContext(AppContext);
  const { state } = context;

  return (
    <Fragment>
      <AccountPreview
        onClick={() =>
          setAccountMenuState({ menuOpen: !accountMenuState.menuOpen })
        }
      >
        <p>
          {`${state.user.name.firstName} ${state.user.name.lastName} - ${
            state.user.role
          }`}
        </p>
      </AccountPreview>
      {accountMenuState.menuOpen === true && (
        <AccountMenuDropDown>
          <ul>
            {/* <li>
                <Link to="/">Account Settings</Link>
              </li> */}
            <li>
              <button
                type="button"
                onClick={() => {
                  logoutUser();
                }}
              >
                Logout
              </button>
            </li>
          </ul>
        </AccountMenuDropDown>
      )}
    </Fragment>
  );
};

export default AccountMenu;
